import { FormControlLabel, Switch } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import __ from "src/utils/Translations";

interface IActiveSwitchProps {
  name: string;
  defaultValue?: boolean;
  disabled?: boolean;
  dataTestId?: string;
}

const ActiveSwitch: FC<IActiveSwitchProps> = ({
  name,
  defaultValue = false,
  disabled = false,
  dataTestId,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => (
        <FormControlLabel
          control={
            <Switch
              checked={!!value}
              onChange={onChange}
              disabled={disabled}
              data-testid={dataTestId}
            />
          }
          label={value ? __("Aktywny") : __("Nieaktywny")}
        />
      )}
    />
  );
};

export default ActiveSwitch;
